import {
    type ProductGroupItem,
    renderProductCard
} from "@/app/(site)/_components/Organisms/ProductGrids/ProductGridCard"

type ProductGridSimpleContentProps = {
    products: ProductGroupItem[]
    params: { locale: string; categories: string[] }
    listHierarchy: string
    desktopEagerCount: number
}

export default function ProductGridSimpleContent({
    products,
    params,
    listHierarchy,
    desktopEagerCount
}: ProductGridSimpleContentProps) {
    return products.map((productGroup, index) =>
        renderProductCard({
            productGroup,
            index,
            isAboveTheFold: index < desktopEagerCount,
            params,
            listHierarchy,
            _key: productGroup.key
        })
    )
}
